import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { OauthInvalid, OauthSuccess } from "../../pages/keys";
import { ThemeShell } from "./ThemeShell";

// Standalone tree for the public OAuth credential popup return routes.
export const OauthPopupApp: React.FC = () => (
  <ThemeShell>
    <HashRouter>
      <Routes>
        <Route path="/oauthsuccess" element={<OauthSuccess />} />
        <Route path="/oauthinvalid" element={<OauthInvalid />} />
      </Routes>
    </HashRouter>
  </ThemeShell>
);
